import { Card } from '@radix-ui/themes'
import { Construction, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface FutureFunctionDialogProps {
  open: boolean
  onClose?: () => void
  preventClose?: boolean
  isPageScoped?: boolean
}

const FutureFunctionDialog = ({ open, onClose, preventClose, isPageScoped }: FutureFunctionDialogProps) => {
  const { t } = useTranslation()
  return (
    <div
      className={`${isPageScoped ? 'absolute' : 'fixed'} inset-0 bg-opacity-50 backdrop-blur-xs overflow-y-auto h-full w-full z-50`}
      style={{ display: open ? 'block' : 'none' }}
    >
      <div className={`relative ${isPageScoped ? 'h-full' : 'min-h-screen'} flex items-center justify-center px-2`}>
        <Card className={`shadow-xl bg-card w-[90%] sm:w-1/2 lg:w-1/4 relative`}>
          {!preventClose && (
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-text-secondary hover:text-text-main transition-colors"
              aria-label="Close dialog"
            >
              <X className="w-5 h-5" />
            </button>
          )}
          <div className="flex flex-col gap-1 items-center p-6">
            <div className="rounded-full p-3 w-fit bg-card-e2">
              <Construction className="text-primary w-8 h-8" />
            </div>
            <h3 className="text-text-primary font-semibold text-xl text-center">
              {t('dialogs.future_title')}
            </h3>
            <p className="text-text-secondary text-sm text-center">
              {t('dialogs.future_desc')}
            </p>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default FutureFunctionDialog
